export default __webpack_public_path__ + "static/google-reviews-706e4a31f29397875710e168728a38f5.svg";